import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, Ref, ref, watch } from 'vue';
import store from '@/store';
import { BModal } from 'bootstrap-vue';
import { getPodAssignments } from '@/api/admin/templateProducts';
import { PrintProviderClass, SelectedProviderVariants } from '@/typings/printify/printProvider';
import { Placeholder, PlaceholderDimension } from './typings';
import { PodProviderConfiguration } from '../typings';
import VariantsConfigurator from '@/components/TemplateProductPodAssigner/VariantsConfigurator/VariantsConfigurator.vue';
import StoreSelector from '@/components/StoreSelector/StoreSelector.vue';
import { PodAssignment, PodService } from '@/api/typings/templateProducts';
import { printProviderFake } from '../printProviderFake';
import { getBlueprint, getPrintProviderById } from '@/api/storesApp/printify';
import { formatAspectRatio } from '@/utils/formatUtils';
import { Provider } from '@/utils/PodProvider.enum';
import RevisionStep from '@/components/TemplateProductPodAssigner/RevisionStep/RevisionStep.vue';
import { getProduct } from '@/api/storesApp/printful';


export default /*#__PURE__*/_defineComponent({
  __name: 'VariantsConfiguratorModal',
  props: {
    templateId: null
  },
  emits: ["input", "save", "close"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: boolean): void;
    (event: 'save', value: Record<string, unknown>): void;
    (event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    templateId: string;
};

const selectedPrintProviders = ref<PrintProviderClass[] | undefined>();
const selectedProductId = ref<string>('');
const productTitle = ref<string>('');
const storeUrl = ref<string>('');
const configurations = ref<PodProviderConfiguration[]>([]);
const loadingVariants = ref<boolean>(true);
const podService = ref<PodService | undefined>(undefined);
const selectedProviderVariants = ref<SelectedProviderVariants[]>([]);
const selectedPodAssignments = ref<PodAssignment[]>([]);
const biggestPlaceholders = ref<PlaceholderDimension[]>([]);
const step: Ref<'selectVariants' | 'finalRevision'> = ref('selectVariants');





const isVisible = ref(true);
const allowedPlaceholders: Ref<string[]> = ref([]);

const user = computed(() => store.state.user);

watch(isVisible, () => {
    emit('input', isVisible.value);
});

onMounted(async () => {
    await initialize();
});

const initialize = async () => {
    loadingVariants.value = true;
    try {
        const podAssignments = await getPodAssignments(props.templateId);
        if (!podAssignments.length) {
            return;
        }
        allowedPlaceholders.value = [...new Set(podAssignments.map((a) => a.placeholderId))];

        const printProviderId = podAssignments[0].printProviderId;
        const productId = podAssignments[0].productId;
        podService.value = podAssignments[0].podService;

        selectedProductId.value = productId;
        if (printProviderId) {
            let printProviderTitle = '';
            try {
                const printProvider = await getPrintProviderById(printProviderId);
                printProviderTitle = printProvider.title;
            } catch (error) {
                console.log('Error getting print provider', error);
            }
            selectedPrintProviders.value = [{ id: Number(printProviderId), title: printProviderTitle }];
        }
        configurations.value = [
            {
                productId,
                provider: podService.value,
                placeholders: podAssignments.map(({ variantId, printProviderId, placeholderId }) => ({
                    variantId,
                    printProviderId:
                        podService.value == Provider.PRINTFUL ? String(printProviderFake.id) : printProviderId,
                    placeholderId
                }))
            }
        ];
    } finally {
        loadingVariants.value = false;
    }
};

const onClose = () => {
    emit('close');
};

const onVariantsSelected = async (value: {
    configurations: PodProviderConfiguration[];
    biggestPlaceholders: Placeholder[];
    selectedProviderVariants: SelectedProviderVariants[];
}) => {
    if (!value.configurations.length) {
        return;
    }
    const productId = value.configurations[0].productId;
    const provider = value.configurations[0].provider;
    selectedPodAssignments.value = value.configurations[0].placeholders.map((ph) => ({
        id: 0,
        podService: provider,
        productId,
        printProviderId: ph.printProviderId,
        variantId: ph.variantId,
        placeholderId: ph.placeholderId
    }));
    selectedProviderVariants.value = value.selectedProviderVariants.map((prov) => {
        return {
            ...prov,
            printProviderName:
                selectedPrintProviders.value && selectedPrintProviders.value.length > 0
                    ? selectedPrintProviders.value[0].title
                    : ''
        };
    });

    if (podService.value == Provider.PRINTIFY) {
        biggestPlaceholders.value = value.biggestPlaceholders.map((x) => {
            return {
                id: x.position,
                width: x.width,
                height: x.height,
                aspectRatio: formatAspectRatio(x.width, x.height)
            };
        });
    } else {
        biggestPlaceholders.value = value.biggestPlaceholders.map((x) => {
            return {
                id: x.file?.type ?? x.position,
                width: x.width,
                height: x.height,
                dpi: x.dpi,
                aspectRatio: x.aspectRatio ?? formatAspectRatio(x.width, x.height)
            };
        });
    }
    try {
        productTitle.value =
            podService.value == Provider.PRINTIFY
                ? (await getBlueprint(Number(productId), storeUrl.value)).title
                : (await getProduct(productId, storeUrl.value)).product.title;
    } catch (error) {
        console.log('Error getting product tittle', error);
    }
    step.value = 'finalRevision';
};

const onDeleteTemplateProduct = () => {
    emit('close');
};

const onSave = async () => {
    const data = {
        podAssignments: selectedPodAssignments.value,
        biggestPlaceholders: biggestPlaceholders.value,
        storeUrl: storeUrl.value
    };
    emit('save', data);
};

return { __sfc: true,selectedPrintProviders, selectedProductId, productTitle, storeUrl, configurations, loadingVariants, podService, selectedProviderVariants, selectedPodAssignments, biggestPlaceholders, step, emit, props, isVisible, allowedPlaceholders, user, initialize, onClose, onVariantsSelected, onDeleteTemplateProduct, onSave, BModal, VariantsConfigurator, StoreSelector, RevisionStep }
}

})